import { useEffect, useRef, useState } from 'react';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';
import { startSignalR, stopSignalR } from '../api/signalr';
import { toast } from 'react-toastify';

export function useSignalR() {
  const connectionRef = useRef<HubConnection | null>(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const init = async () => {
      const conn = await startSignalR();
      connectionRef.current = conn;
      setConnected(conn.state === HubConnectionState.Connected);

      conn.onreconnecting(() => {
        setConnected(false);
        toast.info('Ponowne łączenie z serwerem...', { toastId: 'signalr-reconnecting', autoClose: false });
      });

      conn.onreconnected(() => {
        setConnected(true);
        toast.dismiss('signalr-reconnecting');
        toast.success('Połączono z serwerem', { autoClose: 2000 });
      });

      conn.onclose(() => {
        setConnected(false);
      });

      conn.on('ReceiveNotification', (message: any) => {
        if (message.type === 'success') {
          toast.success(message.message);
        } else if (message.type === 'error') {
          toast.error(message.message);
        } else {
          toast.info(message.message);
        }
      });

      conn.on('SyncCompleted', (message: any) => {
        if (message.success) {
          toast.success(`Synchronizacja ${message.entityType}: ${message.count} rekordów`);
        } else {
          toast.error(`Błąd synchronizacji ${message.entityType}: ${message.error}`);
        }
      });

      conn.on('BulkProgress', (message: any) => {
        // This event can be caught by components via the connection ref
        // It's dispatched as a custom DOM event for decoupling
        window.dispatchEvent(new CustomEvent('bulk-progress', { detail: message }));
      });
    };

    init();

    return () => {
      stopSignalR();
    };
  }, []);

  return { connection: connectionRef, connected };
}
